<template>
	<div class="column">
		<div>
			<div class="subtitle">Valda {{ title }}</div>
			<div class="field">
				<label class="label">Sök</label>
				<div class="control">
					<input
						type="text"
						class="input"
						:placeholder="'Sök ' + title"
						v-model="searchValue"
						@input="search"
						@keyup.esc="clearSearch"
					/>
				</div>
			</div>
		</div>
		<div
			class="panel-list narrow no-hover"
			v-for="(item, index) in selectedItems"
			:key="item.id"
		>
			<p class="panel-list-item">
				{{ item.buildingName ? `${item.buildingName} - ` : `` }} {{ item.name }}
			</p>
			<span class="icon" @click="removeItem(item, index)">
				<i class="fas fa-minus"></i>
			</span>
		</div>
		<div class="panel-list narrow no-hover" v-if="selectedItems.length == 0">
			<p class="header-item">
				{{ searchValue ? `Inga resultat` : blankSelection }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		selectedItems: Array,
		title: String,
		tab: Number
	},
	data() {
		return {
			searchValue: ''
		};
	},
	watch: {
		tab: {
			handler: function() {
				this.clearSearch();
			}
		}
	},
	computed: {
		blankSelection() {
			return this.tab == 3 || this.tab == 4 || this.tab == 1
				? `Inga ${this.title} valda`
				: `Alla ${this.title} valda`;
		}
	},
	methods: {
		removeItem(item, index) {
			this.$emit('removeItem', item, index);
		},
		search() {
			this.$emit('search', this.searchValue);
		},
		clearSearch() {
			this.searchValue = '';
			this.search();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.subtitle {
  min-width: 130px;
  padding-top: 10px;
  margin-bottom: 0.5rem !important;
  font-weight: 600;
}

.label {
  font-size: 12px;
}

.field {
  border-bottom: 1px solid $lightest-grey;
  padding-bottom: 15px;
  margin-bottom: 15px;
  margin: 10px;
  .input {
    background: white;
    max-width: 300px;
  }
}
</style>
